// extracted by mini-css-extract-plugin
export default {"colorPickerItem":"ColorPicker_colorPickerItem__En5cM","colorInput":"ColorPicker_colorInput__2Bopx"};